$(document).on('input change', 'input[name="quantity_rounded"]', function() {
  $(this).closest('[data-add-cart]').find('input[name="quantity"]').val($(this).val());
});

$(document).on('click', 'label[data-sales-unit]', function() {
  const $this = $(this);
  const unitId = $this.attr('data-sales-unit-id');

  if ($this.hasClass('primary')) {
    return;
  }

  if ($('[data-item-detail]').length) {
    // itemdetail
    const $price = $(`[data-prices] [data-price-sales-unit][data-sales-unit-id="${unitId}"]`);
    if ($price.length) {
      $('[data-item-detail] [data-price-sales-unit]').addClass('hide');
      $price.removeClass('hide');
    }

    const $stockinfo = $(`[data-stockinfos] [data-stockinfo][data-stockinfo-unit-id="${unitId}"]`);
    if ($stockinfo.length) {
      $('[data-item-detail] [data-stockinfo]').addClass('hide');
      $stockinfo.removeClass('hide');
    }
  } else {
    // itemlist
    const $item = $this.closest('.shopitem__shop');
    if ($item.length) {
      const url = $this.closest('[data-sales-unit-container]').attr('data-item-price-stockinfo-url');
      if ($item.find('[data-prices]').length) {
        // switch
        const $price = $item.find(`[data-prices] [data-price-sales-unit][data-sales-unit-id="${unitId}"]`);
        if ($price.length) {
          $item.find('[data-prices] [data-price-sales-unit]').addClass('hide');
          $price.removeClass('hide');
        }

        const $stockinfo = $item.find(`[data-stockinfos] [data-stockinfo][data-stockinfo-unit-id="${unitId}"]`);
        if ($stockinfo.length) {
          $item.find('[data-stockinfos] [data-stockinfo]').addClass('hide');
          $stockinfo.removeClass('hide');
        }
      } else if (url) {
        // fetch
        const $price = $item.find('.price');
        const $stockinfo = $item.find('.stock');
        if ($price.length || $stockinfo.length) {
          if ($price.length) {
            $price.addClass('invisible');
          }
          if ($stockinfo.length) {
            $stockinfo.addClass('invisible');
          }

          $.ajax({
            url,
            method: 'GET',
            success: (resp) => {
              $this.closest('[data-sales-unit-container]').removeAttr('data-item-price-stockinfo-url');
              if ($price.length) {
                const $prices = $(resp).find('[data-prices]');
                const $newPrice = $prices.find(`[data-price-sales-unit][data-sales-unit-id="${unitId}"]`);
                if ($newPrice.length) {
                  $newPrice.removeClass('hide');
                }
                $price.replaceWith($prices.html());
              }
              if ($stockinfo.length) {
                const $stockinfos = $(resp).find('[data-stockinfos]');
                $stockinfos.find('[data-stockinfo][data-stockinfo-unit-id]').addClass('hide');
                const $newStockinfo = $stockinfos.find(`[data-stockinfo][data-stockinfo-unit-id="${unitId}"]`);
                if ($newStockinfo.length) {
                  $newStockinfo.removeClass('hide');
                }
                $stockinfo.replaceWith($stockinfos.html());
              }
            },
          });
        } else {
          $this.closest('[data-sales-unit-container]').removeAttr('data-item-price-stockinfo-url');
        }
      }
    }
  }

  const factor = parseFloat($this.attr('data-unit-factor'));
  const puUnit = $this.attr('data-pu-unit');
  const unit = $this.attr('data-sales-unit');

  const decimals = parseInt($this.attr('data-unit-decimals'), 10);
  const roundingFactor = 10 ** decimals;
  const container = $(this).closest('[data-sales-unit-container]');
  const input = $(this).closest('[data-add-cart]').find('input[name="quantity"]');
  const inputRounded = container.find('input[name="quantity_rounded"]');
  const oldUnit = container.attr('data-unit');
  const oldUnitFactor = parseFloat(container.find(`[data-sales-unit="${oldUnit}"]`).attr('data-unit-factor'));
  container.parent().parent().parent().find('[data-pu-unit-label]')
    .last()
    .text(puUnit);
  container.find('[data-sales-unit]').removeClass('primary').addClass('medium-gray');
  $this.removeClass('medium-gray').addClass('primary');
  container.attr('data-unit', unit);
  container.parent().find('[name="quantity_unit"]').val(unitId);

  if (!$this.attr('data-unit-min')) {
    let min = parseFloat(container.find('[data-unit-min]').attr('data-unit-min'));
    min *= oldUnitFactor;
    min /= factor;
    min = Math.ceil(min * roundingFactor) / roundingFactor;
    $this.attr('data-unit-min', `${min}`);
  }
  inputRounded.attr('min', $this.attr('data-unit-min'));

  if (!$this.attr('data-unit-step')) {
    let step = parseFloat(container.find('[data-unit-step]').attr('data-unit-step'));
    step *= oldUnitFactor;
    step /= factor;
    step = Math.ceil(step * roundingFactor) / roundingFactor;
    $this.attr('data-unit-step', `${step}`);
  }
  inputRounded.attr('step', $this.attr('data-unit-step'));

  if (!$this.attr('data-unit-placeholder')) {
    let placeholder = parseFloat(container.find('[data-unit-placeholder]').attr('data-unit-placeholder'));
    placeholder *= oldUnitFactor;
    placeholder /= factor;
    placeholder = Math.ceil(placeholder * roundingFactor) / roundingFactor;
    $this.attr('data-unit-placeholder', `${placeholder}`);
  }
  inputRounded.attr('placeholder', $this.attr('data-unit-placeholder'));

  let qty = parseFloat(input.val());
  if (Number.isNaN(qty)) {
    input.val($this.attr('data-unit-placeholder'));
    inputRounded.val('');
  } else {
    qty *= oldUnitFactor;
    qty /= factor;
    input.val(qty);
    qty = Math.ceil(qty * roundingFactor) / roundingFactor;
    inputRounded.val(qty);
  }
});
